// Smoothly scrolls to an element by id, leaving room for the sticky header
// stack above it. The offset is measured live with getBoundingClientRect so it
// stays correct regardless of body zoom, viewport size or which header is shown.
export function stickyOffset(selectors = ['.site-header', '.acq-nav', '.mode-selector-bar'], gap = 12) {
  let bottom = 0;
  for (const sel of selectors) {
    const el = document.querySelector(sel);
    if (el) {
      const b = el.getBoundingClientRect().bottom;
      if (b > bottom) bottom = b;
    }
  }
  return bottom + gap;
}

export function smoothScrollToId(id, opts = {}) {
  const el = document.getElementById(id);
  if (!el) return;
  const off = stickyOffset(opts.selectors, opts.gap ?? 12);
  const y = el.getBoundingClientRect().top + window.scrollY - off;
  window.scrollTo({ top: Math.max(0, y), behavior: opts.behavior || 'smooth' });
}
